import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConnectionPath, getConnectionNodeName } from './connectionPath';
import { Node } from './types';
import { getCompanyRoleTranslationKey } from './localization';

export default function ConnectionPathDetails({ path, nodes }: {
  path: ConnectionPath | null; nodes: Node[];
}) {
  const { t } = useTranslation();
  const byId = new Map(nodes.map(node => [String(node.id), node]));
  return <Box sx={{ my: 1.5 }} aria-live="polite">
    <Typography variant="subtitle2">{t('graph.investigation.connectionPath')}</Typography>
    {path ? <>
      <Typography variant="caption" color="text.secondary">{t('graph.investigation.pathScope')}</Typography>
      <Box component="ol" sx={{ pl: 2.5, my: 1 }}>
        {path.nodeIds.map((id, index) => {
          const edge = path.edges[index];
          const properties = edge?.properties as any;
          const role = properties?.funktionar_funk_text || properties?.relationship_type || properties?.type;
          const roleKey = typeof role === 'string' ? getCompanyRoleTranslationKey(role) : null;
          const relation = roleKey ? t(roleKey) : role || t('graph.investigation.relationship');
          const provenance = properties?.data_source || properties?.source;
          return <Box component="li" key={id} sx={{ mb: 1 }}>
            <Typography variant="body2">{byId.has(id) ? getConnectionNodeName(byId.get(id)!) : id}</Typography>
            {edge && <>
              <Typography variant="caption" display="block">{String(relation)}</Typography>
              <Typography variant="caption" color="text.secondary" display="block">
                {properties?.start_date || t('graph.investigation.unknownStart')} – {properties?.end_date || t('graph.investigation.noRecordedEnd')}
              </Typography>
              {typeof provenance === 'string' && <Typography variant="caption" display="block">
                {t('graph.investigation.source', { source: provenance })}
              </Typography>}
            </>}
          </Box>;
        })}
      </Box>
    </> : <Alert severity="info">{t('graph.investigation.noPath')}</Alert>}
  </Box>;
}
